// src/components/resume/Skills.js
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fetchSkillCategories } from '../../api';
import { queryKeys } from '../../api/keys';

const Skills = () => {
  const { t, i18n } = useTranslation();
  const { data: categories, isLoading, error } = useQuery({
    queryKey: queryKeys.skillCategories(i18n.language),
    queryFn: () => fetchSkillCategories(i18n.language),
  });

  if (isLoading) {
    return (
      <div className="text-center py-10">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-designColor inline-block"></div>
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500 text-center py-10">Error loading skills: {error.message}</div>;
  }

  if (!categories || categories.length === 0) {
    return <div className="text-center py-10 text-gray-400">No skills found.</div>;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full"
    >
      {/* استخدام grid لعرض فئتين في كل صف */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12">
        {categories.map((category) => (
          <div key={category.id} className="w-full">
            <div className="py-6 font-titleFont flex flex-col gap-4">
              <h2 className={`text-2xl md:text-3xl font-bold text-designColor ${i18n.language === 'ar' ? 'border-r-4' : 'border-l-4'} border-designColor ${i18n.language === 'ar' ? 'pr-4' : 'pl-4'}`}>
                {category.name}
              </h2>
            </div>
            <div className="flex flex-col gap-5">
              {category.skills && category.skills
                .sort((a, b) => a.order - b.order)
                .map((skill) => (
                  <div key={skill.id} className="overflow-x-hidden">
                    <div className="flex justify-between items-center mb-1">
                      <p className="text-sm font-medium text-gray-300 uppercase tracking-wide">
                        {skill.name}
                      </p>
                      <p className="text-sm font-medium text-designColor">
                        {skill.percentage}%
                      </p>
                    </div>
                    <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                      <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: `${skill.percentage}%` }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                        className="h-full bg-gradient-to-r from-blue-500 via-pink-500 to-red-500 rounded-full relative"
                      >
                        <span className="sr-only">{skill.percentage}%</span>
                      </motion.div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default Skills;